export default class AppHeaderElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('app-header', AppHeaderElement);